import { render, staticRenderFns } from "./vat.vue?vue&type=template&id=ff930b14&scoped=true"
import script from "./vat.vue?vue&type=script&lang=js"
export * from "./vat.vue?vue&type=script&lang=js"
import style0 from "./treatmentStepTwoTables.styles.scss?vue&type=style&index=0&id=ff930b14&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff930b14",
  null
  
)

export default component.exports